import type { ContractContactAlertType, ContractContactResource } from "../types";

export interface AlertSummaryRow {
  id: string;
  alertType: ContractContactAlertType;
  destination: string;
}

/**
 * The result screen's recap of who gets alerted: one line per subscription, the channel and
 * the address or number it delivers to. A subscription with nowhere to deliver alerts nobody,
 * so it has no line.
 */
export const alertSummaryRows = (contractContacts: ContractContactResource[]): AlertSummaryRow[] =>
  contractContacts.flatMap((contractContact) => {
    const { alert_type: alertType, alert_destination: destination } = contractContact.attributes;

    if (!alertType || !destination?.trim()) {
      return [];
    }

    return [{ id: String(contractContact.id), alertType, destination }];
  });
